<script setup lang="ts">
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import NavItem from './NavItem.vue';
import { type NavbarIcon } from './types';

defineProps<{
    title: string;
    to?: string;
    href?: string;
    icon?: NavbarIcon;
    iconDefaultColor?: string;
    handleOverflow?: boolean;
    top?: string;
    loading?: boolean;
}>();
const slots = useSlots();
const hasSubItems = computed(() => !!slots.default);
const attrs = useAttrs();
</script>

<template>
    <NavItem
        :title
        position="header"
        :to
        :href
        :icon
        :icon-default-color
        :handle-overflow
        :top
        :loading
        :class="{ clickable: !!attrs.onClick }"
    >
        <template #expand>
            <mr-icon class="expand" :icon="faAngleDown" size="small" />
        </template>
        <template v-if="hasSubItems" #default>
            <slot />
        </template>
    </NavItem>
</template>

<style scoped lang="scss">
.grow-after {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.clickable {
    cursor: pointer;
}
:deep(.expand) {
    margin: 0;
    &:first-child {
        margin-left: 8px;
    }
    &:not(:first-child) {
        margin-right: 8px;
    }
}
</style>
